import { tv } from 'tailwind-variants';

export default tv({
  base: `
    [&_svg]:block
    [&_svg]:w-[55px]
    [&_svg]:lg:w-[105px]
  `,
});
